import { render } from "./SabreJr.vue?vue&type=template&id=d4fc3416&scoped=true"
import script from "./SabreJr.vue?vue&type=script&lang=js"
export * from "./SabreJr.vue?vue&type=script&lang=js"

import "./SabreJr.vue?vue&type=style&index=0&id=d4fc3416&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4fc3416"]])

export default __exports__